import { render, staticRenderFns } from "./ContactBannerComp.vue?vue&type=template&id=8b8e8838&scoped=true&"
import script from "./ContactBannerComp.vue?vue&type=script&lang=js&"
export * from "./ContactBannerComp.vue?vue&type=script&lang=js&"
import style0 from "./ContactBannerComp.vue?vue&type=style&index=0&id=8b8e8838&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b8e8838",
  null
  
)

export default component.exports